var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultPropPic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.75rem",
    height: "1.75rem",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28C21.663 28 28 21.663 28 14C28 6.32303 21.663 0 13.986 0C6.32303 0 0 6.32303 0 14C0 21.663 6.33699 28 14 28ZM14 18.676C9.60319 18.676 6.2672 20.4347 4.96909 22.2074C3.01496 20.0439 1.81456 17.1685 1.81456 14C1.81456 7.24427 7.24427 1.8006 13.986 1.8006C20.7418 1.8006 26.1854 7.24427 26.1994 14C26.1994 17.1685 24.999 20.0439 23.0309 22.2074C21.7328 20.4347 18.3968 18.676 14 18.676ZM14 16.2891C16.68 16.3031 18.7597 14.014 18.7597 11.0269C18.7597 8.22134 16.652 5.87637 14 5.87637C11.348 5.87637 9.22632 8.22134 9.24028 11.0269C9.25424 14.014 11.32 16.2612 14 16.2891Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPropPic);
export default __webpack_public_path__ + "static/media/defaultPropPic.2fc021fcde0aa4612248662aa7fb731c.svg";
export { ForwardRef as ReactComponent };